<template>
  <el-form ref="form" class="image-form" :model="form" :rules="rules">
    <el-form-item prop="images" :class="{'showSearchImg': showSettingSearchImgBtn}">
      <div class="ft-12"><span v-if="isRequired" style="color: red">*</span>{{titleText?titleText:"商品展示图"}} <BatchEditImages v-model="form.images" @change="handleImageChanged" refName="images" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
      <MutiImgUpload
        ref="images"
        v-model="form.images"
        :colorId="colorId"
        :showSettingSearchImgBtn="showSettingSearchImgBtn"
        :autoCropImageParams="autoCropImageParams"
        v-bind="checkImagesLimits"
        @change="handleImageChanged"
        @imageUrlSetChanged="handleImageSetChanged"
        @imageUrlSetSearchChange="handleImageSetSearchChanged"
      />
    </el-form-item>
    <el-form-item style="margin-top:16px" v-if="tipText">
      <p class="tips ft-12">  {{tipText}} </p>
    </el-form-item>
    <!-- <el-form-item style="margin-top: 10px" prop="transparentImages">
      <div class="ft-12">
        透明素材图
        <el-tooltip popper-width="200px" class="item" effect="dark" content="1.上传PNG的透明底图片后，参加部分活动将无需再提交对应的图片素材，并且享有官方会场活动等场景中优先露出的机会，同时在APP搜索推荐、首焦banner、首页入口、频道入口、为你推荐等场景中享有优先露出机会，在商品页中会正常展示商品主图及细节图。 2.图片格式仅支持PNG格式，图片尺寸为800*800px，大小控制在1024kb内 3.注意事项：请将主图中的任意一张进行抠图，边缘处理干净、居中摆放尽量满画布、不得出现牛皮癣，LOGO，水印等情况。" placement="top">
          <i style="font-size: 14px; margin-top: -5px;" class="el-icon-question"></i>
        </el-tooltip>
        <el-link style="margin: 0 20px;line-height: 14px" href="http://psm.jd.com/article/articledetail.html?id=225" target="_blank">点击查看完整规范</el-link>
        <el-link style="line-height: 14px" href="http://drawbot-matting.jd.com/index" target="_blank">在线制作透明图</el-link>
      </div>
      <ImgUpload
        ref="transparentImages"
        :file="form.transparentImages"
        @upload-success="handleTransparentSuccess"
        @del="handleTransparentDel"
        :limitSize="1 * 1024 * 1024"
        :limitWidth="[800, 800]" 
        :limitHeight="[800, 800]" 
        :size="300"
        :isSingle="true"
        limitSuffix=".png"
      />
      <div style="margin-top: 10px" class="tips ft-12">
        <span>PNG	图片尺寸800px*800px，支持png格式</span>
      </div>
    </el-form-item> -->
  </el-form>
</template>

<script>
// jd商品图片块
// 包含商品展示图及透明素材图
// 有主图与普通图的区分

import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import ImgUpload from "@/components/Uploads/ImgUpload";
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'

export default {
  components: {
    MutiImgUpload,
    ImgUpload,
    BatchEditImages
  },
  props: {
    images: Array,
    transparentImages: String,
    colorId: [String, Number],
    showSettingSearchImgBtn:Boolean,
    titleText: String,
    imagesLength: Number,
    isCheckImg:{
      type: Boolean,
      default: true
    },
    imagesLimits: Object,
    tipText: String,
    autoCropImageParams:{
      type: [Object,null],
      default: () => {
        return null
      }
    }
  },
  data() {
    const valiImages = async (rule, value, cb) => {
      const len = value ? value.length : 0;
      const hasErrorImg = (value || []).find(item => typeof item === 'object')
      if (hasErrorImg) {
          return cb(new Error('请移除相关失败图片或正在上传的图片'))
      }
      if (this.isRequired && (len < 1 || len > 10)) {
        return cb(new Error('图片至少上传1张，最多10张'))
      } 
      if (this.$refs.images) {
        let errMsg = await this.$refs.images.method_validImage()
        if (errMsg) {
          return cb(new Error(errMsg));
        } 
      }
      cb()
    }

    const valiTransparentImages = async (rule, value, cb) => {
      let hasErrorImg = false;
      value && value.forEach(item => {
        if (typeof item === 'object') {
          hasErrorImg = true
        }
      })
      if (hasErrorImg) {
        return cb(new Error('请移除相关失败图片或正在上传的图片'))
      } else if (this.$refs.transparentImages) {
        let errMsg = await this.$refs.transparentImages.method_validImage()
        if (errMsg) {
            cb(new Error(errMsg));
        } else {
            cb();
        }
      } else {
        cb()
      }
    }

    return {
      form: {images:[]},
      rules: {
        images: [
          {validator: valiImages}
        ],
        transparentImages: [
          {validator: valiTransparentImages}
        ]
      },
      isRequired: true,
    }
  },
  computed:{
    checkImagesLimits(){
      const { limitWidth,limitHeight,aspectRatio,aspectRatioText, limitSize, ...reset } = this.imagesLimits
      if(this.isCheckImg){
        return this.imagesLimits
      }else{
        return {...reset}
      }
    }
  },
  watch: {
    images: {
      immediate: true,
      handler(v) {
        this.$set(this.form, 'images', v)
      }
    },
    computed: {
    },
    transparentImages: {
      immediate: true,
      handler(v) {
        this.$set(this.form, 'transparentImages', v)
      }
    },
    titleText: {
      immediate: true,
      handler(v) {
        if(v === '长图展示图' || v === '规格长图' ){
          this.isRequired = false
        }
      }
    },
  },
  methods: {
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
    getData() {
      return [JSON.parse(JSON.stringify(this.form.images)), JSON.parse(JSON.stringify(this.form.transparentImages))]
    },
    setData([images, transparentImages] = [[], '']) {
      this.$set(this.form, 'images', images)
      this.$set(this.form, 'transparentImages', transparentImages)
    },
    handleTransparentSuccess(url) {
      this.form.transparentImages = url
      setTimeout(() => {
        this.$refs.form.validateField('transparentImages');
      }, 800);
      this.handleImageChanged();
    },
    handleTransparentDel() {
      this.form.transparentImages = ''
      setTimeout(() => {
        this.$refs.form.validateField('transparentImages');
      }, 800);
      this.handleImageChanged();
    },
    validForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          resolve(valid);
        });
      })
    },
    handleImageChanged() {
      this.$emit('change')
    },
    handleImageSetChanged(checkedImgObj) {
      this.$emit('grandparentImageUrlSetChanged', checkedImgObj)
    },
    // 修改搜索图
    handleImageSetSearchChanged(checkedImgObj) {
      this.$emit('grandparentImageUrlSetSearchChanged', checkedImgObj)
    },
  }
}
</script>

<style lang="scss" scoped>
.image-form {
  background: #f5f7f9;
  padding: 5px 15px;
}
.tips {
  color: #9ca7b6 !important;
}
.showSearchImg{
  ::v-deep .el-form-item__error{
    // top: 136%;
  }
}
</style>